import React from 'react';
import './Navbar.css';

const Navbar = () => {
      return (
            <nav class="navbar custom-navbar navbar-expand-lg navbar-light">
                  {/* fixed-top */}
                  <div class="container">
                        <a class="navbar-brand d-flex text-secondary mx-2" href="/"> <b> &#60;iam<span className='brand'>Raufu</span> /&#62;</b></a>

                        <button class="navbar-toggler custom-toggler mt-2 mx-2" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                              <span class="navbar-toggler-icon"></span>
                        </button>

                        <div class="collapse navbar-collapse"  id="navbarSupportedContent">
                              <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
                                    <li class="nav-item text-center">
                                          <a class="nav-link text-secondary" aria-current="page" href="/about"><i class="fas fa-user"></i> ABOUT</a>
                                    </li>
                                    <li class="nav-item text-center">
                                          <a class="nav-link text-secondary" aria-current="page" href="/projects"><i class="fas fa-project-diagram"></i> PROJECTS</a>
                                    </li>
                                    <li class="nav-item text-center">
                                          <a class="nav-link text-secondary" aria-current="page" href="/expertise"><i class="fas fa-code"></i> EXPERTISE</a>
                                    </li>
                                    <li class="nav-item text-center">
                                          <a class="nav-link text-secondary" aria-current="page" href="/blogs"><i class="fas fa-blog"></i> BLOGS</a>
                                    </li>
                                    <li class="nav-item text-center">
                                          <a class="nav-link text-secondary" aria-current="page" href="/contact"><i class="fas fa-paper-plane"></i> CONTACT</a>
                                    </li>

                              </ul>
                        </div>

                  </div>
            </nav>
      );
};

export default Navbar;